// Update shipment's body for POST /:module/pending-orders/:id/shipments — Orders and Outgoing shipments both post it.

// Only what the form collects: the server fills material, site, customer and display unit from the order.
export const buildOrderShipmentDto = (values) => ({
  shipmentNo: [values.idPrefix, values.idNumber].filter(Boolean).join('-') || undefined,
  terminalId: values.terminalId ? Number(values.terminalId) : undefined,
  shippingDetailsId: values.shippingToId ? Number(values.shippingToId) : undefined,
  shipmentQuantity: Number(values.shipmentQuantity),
  shipmentQuantityUnit: values.shipmentQuantityUnit || undefined,
  dispatchDate: values.dateOfDispatch,
  vesselName: values.vesselName || undefined,
});
